/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreInAppEGSEgsInAppBillingData
 */
export interface FxIdApplicationStoreInAppEGSEgsInAppBillingData {
    /**
     * Entitement id из апи эпика
     * Checkout -> Transaction -> TransactionId -> CopyTransactionById() -> GetEntitlementsCount() -> foreach(CopyEntitlementByIndex()) -> VerifyInFxNative(entitleiemtnId)
     * или
     * Checkout() или OnApplicationStart: GetEntitlementsCount -> CopyEntitlementByIndex() -> VerifyInFxNative
     * @type {string}
     * @memberof FxIdApplicationStoreInAppEGSEgsInAppBillingData
     */
    EntitlementId: string;
    /**
     * access token игрока
     * @type {string}
     * @memberof FxIdApplicationStoreInAppEGSEgsInAppBillingData
     */
    AccessToken: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppEGSEgsInAppBillingData
     */
    DeveloperPayload?: string | null;
    /**
     * sku из админки
     * @type {string}
     * @memberof FxIdApplicationStoreInAppEGSEgsInAppBillingData
     */
    Sku: string;
    /**
     * Флаг, указывающий, что entitlement следует искать по последнему неподтверждённому элементу с заданным catalogItemId,
     * вместо прямого использования EntitlementId. Используется, если entitlementId не был возвращён от Epic.
     * @type {boolean}
     * @memberof FxIdApplicationStoreInAppEGSEgsInAppBillingData
     */
    IsConsumeByCatalogItemId: boolean;
}

/**
 * Check if a given object implements the FxIdApplicationStoreInAppEGSEgsInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData(value: object): value is FxIdApplicationStoreInAppEGSEgsInAppBillingData {
    if (!('EntitlementId' in value) || value['EntitlementId'] === undefined) return false;
    if (!('AccessToken' in value) || value['AccessToken'] === undefined) return false;
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    if (!('IsConsumeByCatalogItemId' in value) || value['IsConsumeByCatalogItemId'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppEGSEgsInAppBillingData {
    return FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppEGSEgsInAppBillingData {
    if (json == null) {
        return json;
    }
    return {
        
        'EntitlementId': json['EntitlementId'],
        'AccessToken': json['AccessToken'],
        'DeveloperPayload': json['DeveloperPayload'] == null ? undefined : json['DeveloperPayload'],
        'Sku': json['Sku'],
        'IsConsumeByCatalogItemId': json['IsConsumeByCatalogItemId'],
    };
}

export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSON(json: any): FxIdApplicationStoreInAppEGSEgsInAppBillingData {
    return FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppEGSEgsInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'EntitlementId': value['EntitlementId'],
        'AccessToken': value['AccessToken'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
        'IsConsumeByCatalogItemId': value['IsConsumeByCatalogItemId'],
    };
}

